module.exports = __webpack_public_path__ + "4de28b7086beae592df4a5c0b812a4ce.pdf";